<template>
  <div
    v-if="accountInfo"
    v-show="showCheckIn && canCheckInNowBooking && autoCheckInFailedBookingId"
    style="z-index: 1; position: fixed; bottom: 58px; right: 10px"
  >
    <div
      class="speech-bubble text-small"
      style="color: white !important"
      @click="checkInButtonClicked"
    >
      Check-In
    </div>
    <div style="text-align: right">
      <v-btn
        id="btnCheckIn"
        @click="checkInButtonClicked"
        fab
        dark
        color="orange"
      >
        <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import validators from "@/helpers/validators";
import businessLogic from "@/helpers/businessLogic";
import apiHelper from "@/helpers/apiHelper";

export default {
  name: "CheckIn",
  data: () => ({
    canCheckInNowBooking: null,
    autoCheckInFailedBookingId: null,
    tryingAutoCheckIn: false,
    lastCheckInTimeMoment: null,
  }),
  computed: {
    ...mapState(["showCheckIn", "qrCode"]),
    ...mapGetters(["mode"]),
  },
  methods: {
    ...mapMutations(["updateLocationInfoFromQrCode"]),
    async checkIn(autoCheckIn, silent) {
      this.canCheckInNowBooking = this.getCanCheckInNowBooking();

      if (this.canCheckInNowBooking) {
        //Try to prevent server from being DDoS by the combination of manual and auto check-ins,
        //But only stop auto check-ins
        if (this.lastCheckInTimeMoment) {
          const diffSeconds = this.time.nowMoment.diff(
            this.lastCheckInTimeMoment,
            "seconds"
          );

          if (autoCheckIn && diffSeconds < 30) {
            console.debug("Stop excessive auto check-ins");
            return false;
          }
        }

        this.lastCheckInTimeMoment = this.time.nowMoment.clone();

        // console.debug("Check in test - " + this.time.nowMoment.format());
        // const response = "Testing";

        const response = await apiHelper.checkIn(
          this.canCheckInNowBooking.bookingId,
          autoCheckIn,
          this.canCheckInNowBooking.branchId,
          silent
        );

        const successCallback = () => {
          this.autoCheckInFailedBookingId = null;
          this.canCheckInNowBooking = null;
          this.updateSystemAlert(null);

          if (!silent && this.$route.name !== "MyBookings") {
            this.$router.push({ name: "MyBookings" });
          }
        };

        const checkInResult = this.commonResponseHandler(
          response,
          window.$msg.checkInSuccess,
          window.$msg.checkInFail,
          null,
          successCallback,
          null,
          silent
        );

        return checkInResult;
      }

      return false;
    },
    showAutoCheckInFailedHandler() {
      // 4. If auto check in failed for the first attempt, show manual check-in button

      if (
        this.canCheckInNowBooking &&
        this.canCheckInNowBooking.bookingId !== this.autoCheckInFailedBookingId
      ) {
        this.autoCheckInFailedBookingId = this.canCheckInNowBooking.bookingId;

        const checkInFailedMsg = window.$msg.checkInReminder.replace(
          "{checkInEndTimeInMinutes}",
          this.settings.system.checkInEndTimeInMinutes
        );

        // const checkInFailedMsg =
        //   "Auto check-in failed. Please check in manually";

        this.updateSystemAlert({
          show: true,
          success: false,
          message: checkInFailedMsg,
        });
      }
    },
    startTryAutoCheckIn() {
      if (this.tryingAutoCheckIn) {
        return;
      }

      this.tryingAutoCheckIn = true;

      this.tryAutoCheckIn();

      setInterval(() => {
        this.tryAutoCheckIn();
      }, window.$settings.autoCheckInInterval);
    },
    async tryAutoCheckIn() {
      if (!this.accountInfo) {
        return;
      }

      //1. App - x sec timer - check if any check-in required now
      this.canCheckInNowBooking = this.getCanCheckInNowBooking();

      if (this.canCheckInNowBooking) {
        const bookingRefId = this.clone(this.canCheckInNowBooking.bookingRefId);

        // console.debug(
        //   "AutoCheckInTimer",
        //   this.onsiteMode,
        //   this.mode.branchId,
        //   this.canCheckInNowBooking.branchId,
        //   bookingRefId
        // );
        if (
          this.onsiteMode &&
          this.mode.branchId === this.canCheckInNowBooking.branchId
        ) {
          //2. If so, auto check in the background
          // console.debug("Auto check-in");
          const checkInSuccess = await this.checkIn(true, true);

          if (checkInSuccess) {
            //3. If auto check-in succeeded, show success notification
            const checkInSuccessMsg = window.$msg.autoCheckInSuccess.replace(
              "{bookingRefId}",
              bookingRefId
            );

            this.updateSystemAlert({
              show: true,
              success: true,
              message: checkInSuccessMsg,
            });
          } else {
            this.showAutoCheckInFailedHandler();
          }
        } else {
          this.showAutoCheckInFailedHandler();
        }
      } else {
        this.autoCheckInFailedBookingId = null;
        // this.updateSystemAlert(null);
      }
    },
    async checkInButtonClicked() {
      if (this.canCheckInNowBooking) {
        //Check if it's in onsiteMode, if not, redirect to ScanQRCode

        if (
          this.onsiteMode &&
          this.mode.branchId === this.canCheckInNowBooking.branchId
        ) {
          // console.debug("Manual check-in");
          await this.checkIn();
        } else {
          this.$router.push({
            name: "ScanQRCode",
            params: { state: "checkIn", title: "Scan QR code to check in" },
          });
        }
      }
    },
    getCanCheckInNowBooking() {
      const canCheckInBookings = this.accountInfo.bookings.filter(
        (x) =>
          validators.isToday(x.startTime, this.time.nowMoment) &&
          x.canCheckInStatus
      );

      if (canCheckInBookings) {
        const canCheckInNowBooking = canCheckInBookings.find((x) => {
          return validators.canCheckIn(
            x.canCheckInStatus,
            x.startTime,
            this.settings.system.checkInStartTimeInMinutes,
            this.settings.system.checkInEndTimeInMinutes,
            this.time.nowMoment
          );
        });

        return canCheckInNowBooking;
      }

      return null;
    },
  },
  watch: {
    accountInfo(newValue, oldValue) {
      if (newValue) {
        this.startTryAutoCheckIn();
      }
    },
    qrCode(newValue, oldValue) {
      if (newValue && newValue.state === "checkIn") {
        //E.g qrCode = https://192.168.10.100:8090/seatbooking/?loc=NLB.TRL.5.BloombergTerminal.1

        //Update locationInfoFromQrCode
        const locationInfo = businessLogic.getLocationInfoFromQrCode(
          newValue.value,
          this.settings.menus.branchMenus
        );

        if (locationInfo) {
          this.updateLocationInfoFromQrCode(locationInfo);

          //Check onsiteMode & extend if really onsite
          this.$nextTick(async () => {
            if (
              this.onsiteMode &&
              this.mode.branchId === this.canCheckInNowBooking.branchId
            ) {
              // console.debug("Manual check-in with QR code");
              await this.checkIn();
            } else {
              const msg = window.$msg.checkInAtTheWrongBranch;

              this.updateSystemDialog({
                show: true,
                title: window.$msg.checkInFail,
                message: msg,
              });
            }
          });
        } else {
          this.updateSystemDialog({
            title: window.$msg.invalidQrCodeTitle,
            message: window.$msg.invalidQrCodeMsg,
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.speech-bubble {
  position: relative;
  background: orange;
  border-radius: 5px;
  width: 70px;
  height: 30px;
  text-align: center;
  right: 15px;
  bottom: 3px;
  padding: 5px 5px 5px 5px;
}

.speech-bubble:before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 60%;
  width: 0;
  height: 0;
  border: 20px solid transparent;
  border-top-color: orange;
  border-bottom: 0;
  border-left: 0;
  margin-left: -10px;
  margin-bottom: -15px;

  /* content: "";
  position: absolute;
  left: 40%;
  background-color: transparent;
  bottom: -40px;
  height: 40px;
  width: 30px;
  border-top-left-radius: 25px;
  box-shadow: 0 -25px 0 0 orange; */
}
</style>